// import { ILogin } from "./../../../../interfaces/login";
import { CommonHttpOption } from "./../../base/common-http-option";
import { CoreService } from "./../../base/core";
import { Injectable } from "@angular/core";
import { ServiceRoute } from "../../base/service-route";
import { Observable, BehaviorSubject } from "rxjs";
import { IChangePass } from "src/app/interfaces/changePass";
import { IForgottenPass } from "src/app/interfaces/forgottenPass";
import { Router } from "@angular/router";
import { IRegister } from "src/app/interfaces/register";
import { IRegistrationConfirrm } from "src/app/interfaces/registrationConfirm";
import { IResendCode } from "src/app/interfaces/resendCode";
import { ICheckActivateUser } from "src/app/interfaces/account-checkActivateUser";
import { CIDService } from "src/app/services/common/cid.service";
import { HidService } from "src/app/services/common/hid.service";
import { BIDService } from "src/app/services/common/bid.service";

@Injectable({
  providedIn: "root"
})
export class AccountService {
  constructor(
    private router: Router,
    private core: CoreService,
    private hidService: HidService,
    private bidService: BIDService,
    private cidService: CIDService
  ) { }

  getSimpleUserInfo(nationalCode: string): Observable<any> {
    return this.core.get(
      ServiceRoute.account.getSimpleUserInfo + nationalCode,
      new CommonHttpOption().headers
    );
  }

  urerList(
    filter: any,
    pageIndex: number,
    pageSize: number
  ): Observable<any> {
    return this.core.get(
      ServiceRoute.account.urerList,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(pageIndex, pageSize)
        .append('HoldingEncryptId', filter && filter.HoldingEncryptId ? filter.HoldingEncryptId : '')
        .append('CompanyEncryptId', filter && filter.CompanyEncryptId ? filter.CompanyEncryptId : '')
        .append('FullName', filter && filter.FullName ? filter.FullName : '')
        .append('NationalCode', filter && filter.NationalCode ? filter.NationalCode : '')
        .append('PhoneNumber', filter && filter.PhoneNumber ? filter.PhoneNumber : '')
    );
  }

  resetPass(data: IChangePass): Observable<any> {
    return this.core.post(
      ServiceRoute.account.changePass,
      data,
      new CommonHttpOption().headers
    );
  }

  userActivationByAdmin(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.account.userActivationByAdmin,
      data,
      new CommonHttpOption().headers
    );
  }

  login(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.account.login,
      data,
      new CommonHttpOption().headers
    );
  }

  userForgetPassByAdmin(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.account.userForgetPassByAdmin,
      data,
      new CommonHttpOption().headers
    );
  }

  logout() {
    this.hidService.setHID("");
    this.cidService.setCID("");
    this.bidService.setBID("");
    localStorage.clear();
    this.router.navigate(["login"]);
  }

  data: IRegister;
  private formData = new BehaviorSubject(this.data);
  currentFormData = this.formData.asObservable();

  register(data: IRegister): Observable<any> {
    return this.core.post(
      ServiceRoute.account.register,
      data,
      new CommonHttpOption().headers
    );
  }

  registerDirect(data: IRegister): Observable<any> {
    return this.core.post(
      ServiceRoute.account.registerDirect,
      data,
      new CommonHttpOption().headers
    );
  }

  updateFormData(data: IRegister) {
    this.formData.next(data);
  }

  confirm(data: IRegistrationConfirrm): Observable<any> {
    return this.core.post(
      ServiceRoute.account.confirmRegistration,
      data,
      new CommonHttpOption().headers
    );
  }

  resendCode(data: IResendCode): Observable<any> {
    return this.core.post(
      ServiceRoute.account.resendCode,
      data,
      new CommonHttpOption().headers
    );
  }

  checkActivateUser(data: ICheckActivateUser) {
    return this.core.post(
      ServiceRoute.account.CheckActivateUser,
      data,
      new CommonHttpOption().headers
    );
  }

  forgotPassword(data: IForgottenPass): Observable<any> {
    return this.core.post(
      ServiceRoute.account.forgottenPassword,
      data,
      new CommonHttpOption().headers
    );
  }

  // from update profile user But call method post
  updateUserProfile(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.account.updateUserProfile,
      data,
      new CommonHttpOption().headers
    );
  }

  getFullName(nationalCode: string) {
    this.core
      .get(
        ServiceRoute.account.getSimpleUserInfo + nationalCode,
        new CommonHttpOption().headers
      )
      .subscribe(res => {
        return res.FullName;
      });
  }

  getUserInfo(): Observable<any> {
    return this.core.get(
      ServiceRoute.account.getUserInfo,
      new CommonHttpOption().headers
    );
  }

  getUserInfoByNationalCode(nationalCode: string): Observable<any> {
    return this.core.get(
      ServiceRoute.account.getUserInfoByNationalCode + nationalCode,
      new CommonHttpOption().headers
    );
  }

  getIntroductionMethodList(): Observable<any> {
    return this.core.get(
      ServiceRoute.account.introductionMethodList,
      new CommonHttpOption().headers
    );
  }
}
